import { matchPath } from 'react-router-dom';

const PROMO_PATHS = ['/login', '/signup'];

export function isPromoPathname(pathname: string): boolean {
  return PROMO_PATHS.some((path) => matchPath(path, pathname) !== null);
}

export function isBeforeWebinar(nowMs: number, targetMs: number): boolean {
  return nowMs < targetMs;
}

export interface TimerPlan {
  delay: number;
  reachesTarget: boolean;
}

export function computeTimerPlan(nowMs: number, targetMs: number, maxDelay: number): TimerPlan {
  const remaining = targetMs - nowMs;
  if (remaining <= 0) {
    return { delay: 0, reachesTarget: true };
  }
  if (remaining <= maxDelay) {
    return { delay: remaining, reachesTarget: true };
  }
  return { delay: maxDelay, reachesTarget: false };
}
